// src/services/weeklyReportCoordinator.js
//
// Who a weekly report (`weekly_reports`) is credited to. Shared by Admin
// Reports and Statistics so both pages credit a report to the same person.
//
// Pure and Firebase-free so it is unit-tested (weeklyReportCoordinator.test.js).

/**
 * True when the report was saved with its own coordinator name. Five early
 * reports (Aug–Oct 2025, before the form required a name) were saved blank.
 */
export const hasOwnCoordinatorName = (r) =>
  Boolean(String(r?.coordinator || r?.coordinatorName || "").trim());

/**
 * The name a weekly report is credited to. The report's own name always wins;
 * an admin-assigned name (`assignedCoordinator`) is used only for a report
 * saved with a BLANK name. The original blank field is never overwritten, so
 * the assignment can be undone. Returns "" when there is neither.
 */
export const reportCoordinatorName = (r) =>
  hasOwnCoordinatorName(r)
    ? r.coordinator || r.coordinatorName
    : String(r?.assignedCoordinator || "").trim();

/**
 * Admin Reports' grouping key: the lowercased first name, letters only, so
 * "Sarah", "sarah " and "Sarah Lee" land on one coordinator card.
 */
export const coordinatorGroupKey = (name = "") =>
  name.toLowerCase().replace(/[^a-z ]/g, "").trim().split(/\s+/)[0];
